import ModuleAssetsLibrary from 'mfAssetsLibrary/AssetsLibrary';

/**
 * Re-export of the assets library module, allowing for mocks
 * (the promise based alias 'mfAssetsLibrary/*' can't be mocked directly) to be used in tests
 */
export { ModuleAssetsLibrary };
